import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { QrTokenService } from './qr-token.service';
import { environment } from '../../environments/environment';

const TOKEN_HEADER = 'token';

export const qrTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(QrTokenService).value;
  // Attach the token only to our own API so it can't leak to third-party hosts/CDNs.
  const isOwnApi = req.url.startsWith(environment.apiUrl);
  if (token && isOwnApi) {
    req = req.clone({ setHeaders: { [TOKEN_HEADER]: token } });
  }
  return next(req);
};
